import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPlay } from '@fortawesome/pro-solid-svg-icons';
import { RefObject } from 'react';
import { Box } from '@mui/material';

export type VideoControlButtonsProps = {
  videoRef: RefObject<HTMLVideoElement>;
  timeRange: [number, number];
  isPlaying: boolean;
  setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>;
  duration: number;
  height: number;
};

export const VideoControlButtons = ({
  videoRef,
  timeRange,
  isPlaying,
  setIsPlaying,
  duration,
  height,
}: VideoControlButtonsProps) => {
  const [start, end] = timeRange;
  const onClick = () => {
    if (isPlaying) {
      videoRef.current?.pause();
    } else {
      if (
        videoRef?.current &&
        videoRef.current.currentTime >= (end * duration) / 100
      ) {
        videoRef.current.currentTime = (start * duration) / 100;
      }
      videoRef.current?.play();
    }

    setIsPlaying((state) => !state);
  };

  return (
    <Box
      sx={{
        width: '37px',
        height: `${height}px`,
        backgroundColor: '#F5F6FA',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        borderRadius: '4px',
      }}
      onClick={onClick}
    >
      <FontAwesomeIcon
        icon={isPlaying ? faPause : faPlay}
        className="text-[25px]"
      />
    </Box>
  );
};
